import React, { useState } from "react";
const NPVCalculator = (props) => {
  const [NPV, SetNPV] = useState("");
  const [inputs, setInputs] = useState({
    rate: "",
    initialCost: "",
    timeline: "",
    Payment: "",
  });
  const [calcs, setCalcs] = useState([]);
  // function validateCurrency(e) {
  //   var x = e.target.value;
  //   var regex = /^[0-9]|\.|,+$/;
  //   if (!x.match(regex)) {
  //     e.target.value = "0";
  //   }
  //   //console.log(`${e.target.name} now says ${e.target.value}`);
  // }

  if (props.Subscribed === false) {
    return (
      <div className="OverviewContainer">
        This feature is only available for subscribers
      </div>
    );
  }
  function handleChange(event) {
    const name = event.target.id;
    let value = event.target.value.replaceAll(",", "");
    if (name !== "rate")
      if (isNaN(parseFloat(value)) == false) value = parseFloat(value);

    setInputs((values) => ({
      ...values,
      [name]: value,
    }));
    // console.log(`inputs[${name}] :>> `, inputs[name]);
  }

  function addNPV() {
    let obj = {
      ID: calcs.count,
      Rate: inputs.rate,
      "Initial Cost": inputs.initialCost,
      Payment: inputs.Payment,
      Timeline: inputs.timeline,
      NPV: getNPV(
        parseFloat(inputs.rate),
        parseFloat(inputs.initialCost),
        parseFloat(inputs.Payment),
        parseFloat(inputs.timeline)
      ),
    };
    setCalcs((arr) => [...arr, obj]);
  }

  const handleValue = (event) => {
    const name = event.target.id;
    let value = event.target.value.replaceAll(",", "");
    if (name !== "rate")
      if (isNaN(parseFloat(value)) == false) value = parseFloat(value);

    setInputs((values) => ({
      ...values,
      [name]: value,
    }));
  };

  // Rate, Payment, Timeline, Initial Value (0)
  function getNPV(rate, initialCost, Payment, timeline) {
    var npv = initialCost;

    for (var i = 0; i < timeline; i++) {
      npv += Payment / Math.pow(rate / 100 + 1, i + 1);
    }

    return Math.floor(npv);
  }

  function clearCalc(indx) {
    const updateCalc = [...calcs];
    updateCalc.splice(indx, 1);
    setCalcs(updateCalc);
  }
  function clearAll() {
    setCalcs([]);
  }
  function clearInputs() {
    setInputs([]);
  }
  function handleSubmit() {
    for (const o in inputs) {
      if (isNaN(parseFloat(inputs[o]))) {
        // console.log(o, inputs[o], typeof o);
        return;
      }
    }
    // console.log(" all value valid");
    SetNPV(
      getNPV(
        parseFloat(inputs.rate),
        parseFloat(inputs.initialCost),
        parseFloat(inputs.Payment),
        parseFloat(inputs.timeline)
      )
    );
    addNPV();
  }

  return (
    <div>
      <br />
      <div className="hoverBox OverviewContainer">
        <h1>Net Present Value Calculator</h1>
        <p>
          This calculator shows future net cash flows over a specific period of
          time in today's dollars.
        </p>
        <div className="flexEven">
          <div className="NPVinputs">
            <span>
              <label htmlFor="rate">Rate : </label>
              <input
                className="text"
                id="rate"
                name="rate"
                onBlur={(event) => {
                  handleValue(event);
                }}
                onChange={(event) => handleChange(event)}
                type="text"
                size="10"
                value={inputs.rate.toLocaleString(undefined, {
                  minimumFractionDigits: 0,
                  maximumFractionDigits: 2,
                })}
              />
              <div className="guidelines">
                How much your money grows each year.
              </div>
            </span>
            <span>
              <label htmlFor="initialCost">Initial Cost : </label>
              <input
                className="text"
                id="initialCost"
                name="initialCost"
                onBlur={(event) => {
                  handleValue(event);
                }}
                value={inputs.initialCost.toLocaleString(undefined, {
                  minimumFractionDigits: 0,
                  maximumFractionDigits: 2,
                })}
                onChange={(event) => handleChange(event)}
                type="text"
                size="10"
              />
              <div className="guidelines">
                The cost of your investment in today’s dollar.
              </div>
            </span>

            <span>
              <label htmlFor="Payment">Payment : </label>
              <input
                className="text"
                id="Payment"
                name="Payment"
                onChange={(event) => handleChange(event)}
                onBlur={(event) => {
                  handleValue(event);
                }}
                type="text"
                size="10"
                value={inputs.Payment.toLocaleString(undefined, {
                  minimumFractionDigits: 0,
                  maximumFractionDigits: 2,
                })}
              />
              <div className="guidelines">Annual cash flow.</div>
            </span>
            <span>
              <label htmlFor="timeline">Timeline : </label>
              <input
                className="text"
                onChange={(event) => handleChange(event)}
                id="timeline"
                name="timeline"
                onBlur={(event) => {
                  handleValue(event);
                }}
                type="text"
                size="10"
                value={inputs.timeline.toLocaleString(undefined, {
                  minimumFractionDigits: 0,
                  maximumFractionDigits: 2,
                })}
              />
              <div className="guidelines">
                How many years into the future you are projecting.
              </div>
            </span>
          </div>
          <div className="NPVButtonContainer">
            <div className="userActionButton NPVbutton" onClick={handleSubmit}>
              Click to Calculate
            </div>
            <div className="userActionButton NPVbutton" onClick={clearAll}>
              Clear Results
            </div>
          </div>

          <div className="NPVresult ">
            {calcs.map((calc) => {
              const index = calcs.indexOf(calc);
              return (
                <div
                  key={calc.ID}
                  className="NPVResultItem"
                  onClick={() => clearCalc(index)}
                >
                  <div className="NPVItemSection">
                    <div className="NPVLabels">
                      {Object.keys(calc).map((label) => {
                        if (label !== "NPV" && label !== "ID")
                          return (
                            <div key={label} className="NPVLabel">
                              <div>{label}: </div>
                              <div>{calc[label]}</div>
                            </div>
                          );
                      })}
                    </div>
                    <div className="NPVCalc">
                      <h2>NPV</h2>
                      <h2>#{index + 1}</h2>
                      <h2>{calc.NPV}</h2>
                    </div>
                  </div>
                  <div className="NPVClick">Click to Clear</div>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </div>
  );
};
export default NPVCalculator;
